// extracted by mini-css-extract-plugin
export var bluebox = "styles-module--bluebox--ad1aa";
export var container = "styles-module--container--c5a22";
export var reverse = "styles-module--reverse--3c48c";